import React from 'react';
import '../template-file-css/document-file-template.css';


export const AJC_DemographicForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='AJC_DemographicForm' className='file-pdf-document'>
            <div className='file-template'>
                <h3>Legal and Family Information:</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legal Guardian:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalFamilyInformation_1" name="cbLegalFamilyInformation_1" className='add-only' value="LegalFamilyInformation_1" />Self 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalFamilyInformation_2" name="cbLegalFamilyInformation_2" className='add-only' value="LegalFamilyInformation_2" />DHR 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalFamilyInformation_3" name="cbLegalFamilyInformation_3" className='add-only' value="LegalFamilyInformation_3" />DJJ 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegalFamilyInformation_4" name="cbLegalFamilyInformation_4" className='add-only' value="LegalFamilyInformation_4" />Parent
                        </td>
                    </tr>                                                                           
                    <tr>
                    <td className='w-750'>
                            <input type="checkbox" id="cbLegalFamilyInformation_other" name="cbLegalFamilyInformation_other" className='add-only' value="LegalFamilyInformation_other" />Other
                            <input type="text" id="txtLegalFamilyInformation_other" name="txtLegalFamilyInformation_other" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mother (Biological, Adoptive, Step): </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="text" id="txtMotherStep" name="txtMotherStep" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Telephone #: (home)</span></td>
                        <td className='w-375'><span className='eleHeader'>(work)</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="text" id="txtMotherTelephone" name="txtMotherTelephone" className='add-only' /></td>
                        <td className='w-375'> <input type="text" id="txtMotherwork" name="txtMotherwork" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Address: </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="text" id="txtMotherAddress" name="txtMotherAddress" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Father (Biological, Adoptive, Step):  </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="text" id="txtFatherStep" name="txtFatherStep" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Telephone #: (home)</span></td>
                        <td className='w-375'><span className='eleHeader'>(work)</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="text" id="txtFatherTelephone" name="txtFatherTelephone" className='add-only' /></td>
                        <td className='w-375'> <input type="text" id="txtFatherwork" name="txtFatherwork" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Address: </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="text" id="txtFatherAddress" name="txtFatherAddress" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                <tr>
                        <td className='w-375'><span className='eleHeader'>Emergency Contact Info: </span></td>
                        <td className='w-375'><span className='eleHeader'>Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="text" id="txtEmergencyContactInfo" name="txtEmergencyContactInfo" className='add-only' /></td>
                        <td className='w-375'> <input type="text" id="txtPhone_1" name="txtPhone_1" className='add-only' /></td>
                    </tr>
                </table>
                <h3>Funding Information:</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Type of Payment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPayment_1" name="cbPayment_1" className='add-only' value="Payment_1" />Medicaid 
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPayment_2" name="cbPayment_2" className='add-only' value="Payment_2" />Self/Private Pay
                        </td>
                       
                    </tr>                                                                           
                    <tr>
                    <td className='w-750'>
                            <input type="checkbox" id="cbPayment_other" name="cbPayment_other" className='add-only' value="Payment_other" />Other
                            <input type="text" id="txtPayment_other" name="txtPayment_other" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insurance Card Number:</span>
                        <span className="small block">(please provide a copy of insurance card)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="text" id="txtInsuranceCardNumber" name="txtInsuranceCardNumber" className='add-only' /></td>
                    </tr>
                </table>
                <h3>Medical Information:</h3>
                <table>
                <tr>
                        <td className='w-375'><span className='eleHeader'>Primary Care Physician Name: </span></td>
                        <td className='w-375'><span className='eleHeader'>Primary Care Physician telephone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="text" id="txtPrimaryCarePhysicianName" name="txtPrimaryCarePhysicianName" className='add-only' /></td>
                        <td className='w-375'> <input type="text" id="txtPrimaryCarePhysicianTelephone" name="txtPrimaryCarePhysicianTelephone" className='add-only' /></td>
                    </tr>
                    <tr>
                      <td className='w-750'><span className='eleHeader'>Primary Care Physician address:</span></td>
                    </tr>
                    <tr>
                    <td className='w-750'> <input type="text" id="txtPrimaryCarePhysicianAddress" name="txtPrimaryCarePhysicianAddress" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                  <span className='eleHeader'>Current Medication</span>
                   <textarea id="txtCurrentMedication" name="txtCurrentMedication" className='add-only' />
                </p>
                <p className='w-750'>
                  <span className='eleHeader'>Medical Issues/Concerns:</span>
                   <textarea id="txtMedicalIssues" name="txtMedicalIssues" className='add-only' />
                </p>
                <h3>Symptoms/Behavioral Information:</h3>
                <table>
                <tr>
                        <td className='w-187'>
                          <span className='eleHeader'>Feelings</span>
                        </td>
                        <td className='w-187'>
                           <span className='eleHeader'>Thoughts</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Behavior</span>
                        </td>
                        <td className='w-187'>
                           <span className='eleHeader'>Physical Symptoms</span> 
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFeelings_1" name="cbFeelings_1" className='add-only' value="Feelings_1" />Depressed
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughts_1" name="cbThoughts_1" className='add-only' value="Thoughts_1" />Obsessive
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_1" name="cbBehavior_1" className='add-only' value="Behavior_1" />Eating Less
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_1" name="cbPhysicalSymptoms_1" className='add-only' value="PhysicalSymptoms_1" />Insomnia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFeelings_2" name="cbFeelings_2" className='add-only' value="Feelings_2" />Angry
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughts_2" name="cbThoughts_2" className='add-only' value="Thoughts_2" />Worthless
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_2" name="cbBehavior_2" className='add-only' value="Behavior_2" />Attempting Suicide
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_2" name="cbPhysicalSymptoms_2" className='add-only' value="PhysicalSymptoms_2" />Weight Gain/Loss
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFeelings_3" name="cbFeelings_3" className='add-only' value="Feelings_3" />Anxious
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughts_3" name="cbThoughts_3" className='add-only' value="Thoughts_3" />Unmotivated
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_3" name="cbBehavior_3" className='add-only' value="Behavior_3" />Crying
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_3" name="cbPhysicalSymptoms_3" className='add-only' value="PhysicalSymptoms_3" />Vomiting
                        </td>
                    </tr>  
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFeelings_4" name="cbFeelings_4" className='add-only' value="Feelings_4" />Out of Control
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughts_4" name="cbThoughts_4" className='add-only' value="Thoughts_4" />Confident
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_4" name="cbBehavior_4" className='add-only' value="Behavior_4" />Drinking/Using Drugs
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_4" name="cbPhysicalSymptoms_4" className='add-only' value="PhysicalSymptoms_4" />Excessive Sleep
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFeelings_5" name="cbFeelings_5" className='add-only' value="Feelings_5" />Happy
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughts_5" name="cbThoughts_5" className='add-only' value="Thoughts_5" />Suicidal
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_5" name="cbBehavior_5" className='add-only' value="Behavior_5" />Poor Concentration
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_5" name="cbPhysicalSymptoms_5" className='add-only' value="PhysicalSymptoms_5" />Loss of Memory
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFeelings_6" name="cbFeelings_6" className='add-only' value="Feelings_6" />Hopefu
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughts_6" name="cbThoughts_6" className='add-only' value="Thoughts_6" />Homicidal
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_6" name="cbBehavior_6" className='add-only' value="Behavior_6" />Self-Injury
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_6" name="cbPhysicalSymptoms_6" className='add-only' value="PhysicalSymptoms_6" />Tightness in Chest
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-187'>
                             <input type="checkbox" id="cbFeelings_other" name="cbFeelings_other" className='add-only' value="Feelings_other" />Other
                            <input type="text" id="txtFeelings_other" name="txtFeelings_other" className='add-only' />
                        </td>
                        <td className='w-187'>
                        <input type="checkbox" id="cbThoughts_other" name="cbThoughts_other" className='add-only' value="Thoughts_other" />Other
                            <input type="text" id="txtThoughts_other" name="txtThoughts_other" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBehavior_other" name="cbBehavior_other" className='add-only' value="Behavior_other" />Other
                            <input type="text" id="txtBehavior_other" name="txtBehavior_other" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPhysicalSymptoms_other" name="cbPhysicalSymptoms_other" className='add-only' value="PhysicalSymptoms_other" />Other
                            <input type="text" id="txtPhysicalSymptoms_other" name="txtPhysicalSymptoms_other" className='add-only' />
                        </td>
                    </tr>                               
                </table>
            </div>
        </form>

    )
}
                
                

                

                    
                    

               

           
